export const messages = {
    common: {
        genericError: 'Si è verificato un problema, riprova più tardi.',
        checkData: 'Controlla i dati inseriti e riprova.',
    },
    auth: {
        requiredCredentials: 'Email e password sono campi obbligatori',
        invalidCredentials: 'Credenziali non valide.',
        accountNotConfirmed: 'L’account non è ancora confermato.',
        accountAlreadyExists: "Esiste già un account con questa email. Usa un'altra email oppure accedi.",
        companyAlreadyExists: 'La ragione sociale associata alla Partita IVA o al Codice Fiscale inserito è già presente nel sistema.',
    },
    registration: {
        requiredAccountData: 'Ragione Sociale, Partita IVA, Codice Fiscale, Telefono e PEC sono campi obbligatori',
        invalidPassword: 'Il formato della password non è valido: deve contenere almeno 8 caratteri, una maiuscola, una minuscola, un numero e un carattere speciale.',
        invalidPhone: 'Il formato del numero di telefono non è valido. Esempio: +392228460982',
        invalidCognitoPassword: 'La password non rispetta i requisiti richiesti.',
        validationFailed: 'I dati inseriti non sono validi. Controlla tutti i campi.',
        success: 'La registrazione è andata a buon fine. Puoi procedere con il primo accesso.',
    },
} as const;

export const getRegistrationErrorMessage = (error: any): string => {
    switch (error?.code || error?.name) {
        case 'UsernameExistsException':
            return messages.auth.accountAlreadyExists;
        case 'DUPLICATE_COMPANY_ID':
            return messages.auth.companyAlreadyExists;
        case 'InvalidPasswordException':
            return messages.registration.invalidCognitoPassword;
        case 'InvalidParameterException':
            return messages.common.checkData;
        case 'UserLambdaValidationException':
            return messages.registration.validationFailed;
        default:
            return messages.common.genericError;
    }
};
